import types from './types';

export default (state = {}, { type, payload = {} }) => {
    switch (type) {
        case types.SET_CONFIGS:
            return { ...state, ...payload };
        default:
            return state;
    }
};
